import ReactPaginate, { ReactPaginateProps } from "react-paginate";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useThemeMode } from "@/../_metronic/partials";

type Props = ReactPaginateProps;

export function PaginationLinks({ ...rest }: Props) {
	const { mode } = useThemeMode();

	const buttonColor = mode === "dark" ? "text-white" : "text-dark";

	return (
		<ReactPaginate
			containerClassName="pagination"
			pageClassName="page-item"
			pageLinkClassName="page-link"
			activeClassName="active"
			nextClassName="page-item"
			nextLinkClassName="page-link"
			previousClassName="page-item"
			previousLinkClassName="page-link"
			previousLabel={
				<i className={buttonColor}>
					<FaChevronLeft />
				</i>
			}
			nextLabel={
				<i className={buttonColor}>
					<FaChevronRight />
				</i>
			}
			{...rest}
		/>
	);
}
